import axios from "axios";

const API_URL = process.env.REACT_APP_MICROCMS_API_URL;
const API_KEY = process.env.REACT_APP_MICROCMS_API_KEY;

export const getTopics = async (pageNumber, pageSize) => {
  try {
    const response = await axios.get(`${API_URL}/topics`, {
      headers: { "X-MICROCMS-API-KEY": API_KEY },
      params: {
        limit: pageSize,
        offset: (pageNumber - 1) * pageSize,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch topics", error);
    return [];
  }
};

export const getTopicById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/topics`, {
      headers: { "X-MICROCMS-API-KEY": API_KEY },
      params: {
        ids: id,
      },
    });
    return response.data?.contents?.[0];
  } catch (error) {
    console.error("Failed to fetch topic", error);
    return null;
  }
}

export const getTopicByDraftKey = async (draftKey) => {
  try {
    const response = await axios.get(`${API_URL}/topics`, {
      headers: { "X-MICROCMS-API-KEY": API_KEY },
      params: {
        draftKey: draftKey,
      },
    });
    return response.data?.contents?.[0];
  } catch (error) {
    console.error("Failed to fetch topic", error);
    return null;
  }
}
